import { schema } from "normalizr";
import { ConnectionRequest } from "records/connection-request";

export const ConnectionRequestSchema = new schema.Entity(
    "connectionRequests",
    {},
    {
        idAttribute: "_id",
    }
);

(ConnectionRequestSchema as any).record = ConnectionRequest;

export const ConnectionRequestsSchema = new schema.Array(ConnectionRequestSchema);
